const UNSUPPORTED_CHARS = /[.*+?^${}()|[\]\\]/g;
const EMPTY_CHAR = '\\$&';
export default search => search === null || search === void 0 ? void 0 : search.replace(UNSUPPORTED_CHARS, EMPTY_CHAR);
//# sourceMappingURL=escapeRegex.js.map